/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedModelDeliveryMethodPageResponse } from '../../models/paged-model-delivery-method-page-response';

export interface ListAllDeliveryMethodsByMerchantIdAndSiteId$Params {
  merchantId: string;
  siteId: string;
}

export function listAllDeliveryMethodsByMerchantIdAndSiteId(http: HttpClient, rootUrl: string, params: ListAllDeliveryMethodsByMerchantIdAndSiteId$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelDeliveryMethodPageResponse>> {
  const rb = new RequestBuilder(rootUrl, listAllDeliveryMethodsByMerchantIdAndSiteId.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.path('siteId', params.siteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelDeliveryMethodPageResponse>;
    })
  );
}

listAllDeliveryMethodsByMerchantIdAndSiteId.PATH = '/merchants/{merchantId}/sites/{siteId}/delivery/methods';
